import {Component, HostBinding, Input, OnDestroy, OnInit} from "@angular/core";
import {FUINavigationBranch} from "./navigation-branch.model";
import {FUINavigationService} from "../../navigation.service";
import {FUINavigationLinkAvailability} from "../../navigation-link/navigation-link.model";
import {Subscription} from "rxjs";

@Component({
    selector: "fui-navigation-branch",
    templateUrl: "./navigation-branch.component.html",
    styleUrls: ["./navigation-branch.component.scss"],
    standalone: false
})
export class FUINavigationBranchComponent implements OnInit, OnDestroy {
    FUINavigationLinkAvailability = FUINavigationLinkAvailability;

    @Input() branch: FUINavigationBranch;

    @HostBinding("class.mobile") private get mobile() {
        return this.navigationService.useMobileNav();
    };

    private subscriptions: Subscription = new Subscription();

    constructor(public navigationService: FUINavigationService) {
    }

    ngOnInit() {
        this.subscriptions.add(this.navigationService.activeGroup$.subscribe(
            (activeGroup) => {
                for (const link of this.branch.links) {
                    if (activeGroup === link) {
                        this.navigationService.setActiveBranch(this.branch);
                    }
                }
            }
        ));
        this.subscriptions.add(this.navigationService.activeLink$.subscribe(
            (activeLink) => {
                for (const link of this.branch.links) {
                    if (activeLink === link) {
                        this.navigationService.setActiveBranch(this.branch);
                    }
                }
            }
        ));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
